import React, { useEffect, useState } from "react";
import {
  DateField,
  RecordContextProvider,
  ReferenceField,
  TextField,
  useDataProvider,
  useRedirect,
} from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Button, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { useNotifyError } from "utils/useNotifyError";
import { CYCLIC_SCHEDULE, DISCIPLINES, PROFESSORS, StudentServicePath } from "utils/constants";

const CyclicScheduleMobileExpanded = ({ record }) => {
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const notifyError = useNotifyError();

  const [disciplines, setDisciplines] = useState();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!expanded) return;
    dataProvider
      .customRequest(studentRequests.getCyclicScheduleExpanded(record.id), null, "GET")
      .then(res => setDisciplines(res.data?.disciplines))
      .catch(notifyError);
  }, [expanded, record.id, dataProvider, notifyError]);

  return (
    <Accordion
      sx={{ width: "100%" }}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
        <Typography sx={{ fontWeight: "bold" }}>Детайли</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ width: "100%" }}>
        {disciplines &&
          (disciplines.length === 0 ? (
            <p>Няма налични специалности</p>
          ) : (
            disciplines.map((item, idx) => (
            <RecordContextProvider
              key={idx}
              value={item}
            >
              <div style={settings.style.shadowBoxMobile}>
                <MobileListRow
                  fields={[
                    {
                      label: "Дисциплина",
                      value: (
                        <ReferenceField
                          source="disciplineId"
                          reference={administrationRequests.getDisciplinesSelect()}
                        >
                          <TextField source="name" />
                        </ReferenceField>
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Начало на занятия",
                      value: (
                        <DateField
                          source="classesStartDate"
                          locales="bg-BG"
                        />
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Край на занятия",
                      value: (
                        <DateField
                          source="classesEndDate"
                          locales="bg-BG"
                        />
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Начало на сесия",
                      value: (
                        <DateField
                          source="examsStartDate"
                          emptyText="-"
                          locales="bg-BG"
                        />
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Край на сесия",
                      value: (
                        <DateField
                          source="examsEndDate"
                          emptyText="-"
                          locales="bg-BG"
                        />
                      ),
                    },
                  ]}
                />
                <SecuredComponent permission={permissions.canUpdateCyclicSchedulesProfessors}>
                  <Button
                    onClick={() =>
                      redirect(`/${StudentServicePath}${CYCLIC_SCHEDULE}/${DISCIPLINES}/${item.id}/${PROFESSORS}`)
                    }
                    size="small"
                    variant="contained"
                    color="secondary"
                    startIcon={<AddIcon />}
                  >
                    Преподавател
                  </Button>
                </SecuredComponent>
              </div>
            </RecordContextProvider>
            ))
          ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default CyclicScheduleMobileExpanded;
